import { useEffect, useState } from "react";
import "./../styles/search.css";
import { HashLoader } from "react-spinners";
import { IoSearch } from "react-icons/io5";
import ToastNotification, {
    showToast,
} from "../components/toasts/ToastNotification";
import { searchProduct } from "../api/search.api";
import { useNavigate } from "react-router-dom";

export const Search = () => {
    const [loading, setLoading] = useState(false);
    const [query, setQuery] = useState("");
    const [resp, setResp] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Khám Phá Các Sản Phẩm Mới";
    }, []);

    const fetchResp = async () => {
        try {
            setLoading(true);
            
            const res = await searchProduct(query);

            if (res.success) {
                setResp(res.data.resp || []);
            }
        } catch (error) {
            showToast(error.message, "error");
        } finally {
            setLoading(false);
        }
    };

    const handleKeyDown = async(event) => {
        if (event.key === "Enter") {
            await fetchResp();
        }
    };

    const handleFormatPackagePrice = (packages) => {
        const prices = packages.map(pkg => pkg.price);
        const minPrice = Math.min(...prices).toLocaleString();
        const maxPrice = Math.max(...prices).toLocaleString();

        return `${minPrice}đ~${maxPrice}đ`;
    }

    if (loading) {
        return (
            <div style={{ height: "100vh" }} className="loader-container">
                <HashLoader color="#fff" />
            </div>
        );
    }

    return (
        <div className="user-search-container">
            <ToastNotification />
            <div className="user-search-wrapper">
                <h3>Khám Phá Các Sản Phẩm Mới</h3>
                <div className="search-input-container">
                    <input
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        onKeyDown={handleKeyDown}
                        type="text"
                        className="user-search-input"
                    ></input>
                    <IoSearch onClick={fetchResp} className="user-search-icon" />
                </div>
                {
                    resp.length > 0 ?
                    resp.map((prod) => (<div onClick={() => navigate(`/product/${prod.product_slug}`)} className="search-products-container">
                        <img className="search-product-img" src={prod.product_imgs[0]} alt="Product"></img>
                        <div className="search-product-information-container">
                            <p className="search-product-name">{prod.product_name}</p>
                            {(prod.product_type === "game_account" || prod.product_type === "utility_account") &&
                                <p className="search-product-price">{prod.product_attributes.price.toLocaleString() || 0}đ</p>
                            }
                            {prod.product_type === 'topup_package' &&
                                <p className="search-product-price">{ handleFormatPackagePrice(prod.product_attributes.packages)}</p>}

                        </div>
                    </div>)
                        )
                        :
                    <p>Không tìm thấy sản phẩm</p>
                }
            </div>
        </div>
    );
};
